<template>
<svg viewBox="0 0 18 18" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-yujing`]" width="1em" height="1em" v-bind="$attrs"><path d="M13.0913 15.0824L13.0949 7.54038C13.0949 6.43236 12.6596 5.38729 11.8699 4.59764C11.0803 3.80799 10.055 3.3727 8.94696 3.3727C7.83894 3.3727 6.79387 3.80799 6.00422 4.59764C5.21458 5.38729 4.77928 6.43236 4.77928 7.54038L4.78468 15.0806L3.67485 15.0824L3.66406 7.54218C3.66406 6.83168 3.80436 6.14096 4.08137 5.48802C4.34758 4.86026 4.72892 4.29545 5.21458 3.80979C5.70024 3.32413 6.26504 2.9428 6.8928 2.67659C7.54395 2.39958 8.23466 2.25928 8.94517 2.25928C9.65567 2.25928 10.3266 2.39958 10.9777 2.67659C11.6055 2.9428 12.1703 3.32413 12.656 3.80979C13.1416 4.29545 13.523 4.86026 13.7892 5.48802C14.0662 6.13916 14.2065 6.82988 14.2065 7.53858V15.0788L13.0913 15.0824Z"/><path d="M15.317 16.1728H2.68261C2.37502 16.1728 2.125 15.9228 2.125 15.6152 2.125 15.3076 2.37503 15.0576 2.66282 15.0576H15.2972C15.6245 15.0576 15.8746 15.3076 15.8746 15.6152 15.8746 15.9228 15.6245 16.1728 15.317 16.1728zM11 9.20787H9.34887V6L7 9.9382H8.7098V13L11 9.20787z"/></svg>
</template>
<script>

export default {
  name: 'IconYujing',
  props: {
    prefix: {
        type: String,
        default: 'zhilv',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
